import * as React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import styled from '@emotion/styled';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';


const StyledDiv = styled.div`
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 100;
`;


export default function SimpleBottomNavigation() {
    const [value, setValue] = React.useState(0);
    const navigate = useNavigate();

    useEffect(() => {
      if (value === 0) {
        navigate("/");
      } else if (value === 1) {
        navigate("/About");
      }
    }, [value, navigate]); 

  return (
    <Box>
    <StyledDiv>
      <BottomNavigation
        style = {{backgroundColor:'#001'}}
        showLabels={false}
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        <BottomNavigationAction style={{color: 'whitesmoke'}} selected={false} label="Search" icon={<SearchIcon />} />
        <BottomNavigationAction style={{color: 'whitesmoke'}} selected={false} label="About" icon={<InfoIcon />} />

      </BottomNavigation>
    </StyledDiv>
    </Box>
  );
}